module.exports = __webpack_public_path__ + "static/img/desktop-hero.de4a9c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/desktop-hero.jpg
// module id = Pon/
// module chunks = 1